import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';

interface CommitteeModeSelectorProps {
  value: string;
  onChange: (mode: string) => void;
  disabled?: boolean;
}

export const CommitteeModeSelector: React.FC<CommitteeModeSelectorProps> = ({
  value,
  onChange,
  disabled = false
}) => {
  const { darkMode } = useTheme();
  
  return (
    <div className="committee-mode-selector">
      <label className={`block text-sm font-medium mb-1 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
        Committee Execution Mode
      </label>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        className={`w-full px-3 py-2 border rounded-md ${
          darkMode 
            ? 'bg-gray-700 border-gray-600 text-white' 
            : 'bg-white border-gray-300 text-gray-900'
        }`}
      >
        <option value="sequential">Sequential (One after another)</option>
        <option value="parallel">Parallel (Simultaneous)</option>
        <option value="iterative">Iterative (Multiple rounds)</option>
        <option value="collaborative">Collaborative (Shared workspace)</option>
        <option value="debate">Debate (Critique & respond)</option>
      </select>
      
      {/* Mode description */}
      <div className={`mt-1 text-xs ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
        {value === 'sequential' && (
          'Each persona works in sequence, building on previous contributions.'
        )}
        {value === 'parallel' && (
          'All personas work simultaneously and independently.'
        )}
        {value === 'iterative' && (
          'Multiple rounds of sequential execution to refine the output.'
        )}
        {value === 'collaborative' && (
          'Personas work with a shared workspace, seeing and building on each other\'s work.'
        )}
        {value === 'debate' && (
          'Personas propose ideas, critique each other\'s work, and respond to critiques.'
        )}
      </div>
    </div>
  );
};
